"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Hindi (Template)
var strings = {
  prefixAgo: null,
  prefixFromNow: 'अब से',
  suffixAgo: 'पहले',
  suffixFromNow: 'मेे',
  seconds: 'एक मिनट से कम',
  minute: 'मिनट',
  minutes: '%d मिनट',
  hour: 'करीब एक घंटा',
  hours: 'करीब %d घंटे',
  day: 'दिन',
  days: '%d दिन',
  month: 'तक़रीबन एक महीना',
  months: '%d महीने',
  year: 'लगभग एक साल',
  years: '%d साल',
  wordSeparator: ' '
};
var _default = strings;
exports["default"] = _default;